<template>
    <CCard style="background-color: #1e8449">
        <CCardBody>
            <CRow>
                <div class="col-sm-4" style="text-align: center">
                    <img src="@/assets/images/logo_nomina.png" width="150" />
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-12">
                            <label class="label">
                                #Agente:{{item.agente}}
                            </label>
                        </div>
                        <div class="col-12">
                            <label class="label">
                                TIPO DE UNIDADES REQUERIDAS :{{item.tipo_unidad}}
                            </label>
                        </div>
                    </div>
                </div>
                <div v-if="item.is_demo" class="col-sm-2" style="text-align: center">
                    <img src="@/assets/images/ic_star.png" width="60" />
                </div>
                <a class="col-sm-12">
                    <div class="btn-detail" @click="onShowItem(item)"> 
                        {{ $t('directories.detail') }}
                    </div>
                </a>
            </CRow>
        </CCardBody>
    </CCard>
</template>

<script>

export default {
    name: "ChargeItem",
    props: ['item'],
    methods: {
        onShowItem() {
            this.$emit('onShowItem', this.item);
        }
    }
}
</script>
